import { enumToColumnNames } from '../../constants/constant';

export const arrayContains = (array, string) => {
	let index;
	for (index = 0; index < array?.length; index++) {
		if (array[index]?.name?.toLowerCase() == string?.toLowerCase()) {
			return true;
		}
	}
	return false;
};

export const isEmpty = (array) => {
	return (
		array == undefined || array.length == 0 || !Object.entries(array).length
	);
};

export const isEmptyMetrics = (array) => {
	if (array == undefined || array.length == 0) {
		return true;
	}
	let index;
	for (index = 0; index < array?.length; index++) {
		if (array[index]?.metrics.length > 0) {
			return false;
		}
	}
	return true;
};

export const arrayEquals = (array, compareArr) => {
	if (
		array == undefined ||
		compareArr == undefined ||
		array.length != compareArr.length
	) {
		return false;
	}
	let index, innerIndex;
	for (index = 0; index < array.length; index++) {
		if (array[index]?.metrics?.length != compareArr[index]?.metrics?.length) {
			return false;
		}
		for (
			innerIndex = 0;
			innerIndex < compareArr[index].metrics?.length;
			innerIndex++
		) {
			if (
				!arrayContains(
					array[index]?.metrics,
					compareArr[index].metrics[innerIndex]?.name
				)
			) {
				return false;
			}
		}
	}
	return true;
};

export const containsSubString = (string, searchText) => {
	if (searchText?.length > 1) {
		let tempStr = string?.toLowerCase();
		let characters = tempStr.split('');
		let index;
		for (index = 0; index < characters?.length; index++) {
			if (characters[index].includes(searchText?.toLowerCase())) {
				return true;
			}
		}

		let words = tempStr.split(' ');
		for (index = 0; index < words?.length; index++) {
			if (words[index].includes(searchText?.toLowerCase())) {
				return true;
			}
		}
		return false;
	} else if (string != null && string != '') {
		return string.includes(searchText) ? true : false;
	}
};

export const getMetricFromAPIList = (
	currentAPIList,
	name,
	metric,
	filterSelection
) => {
	let element, index, innerIndex;
	for (index = 0; index < currentAPIList?.length; index++) {
		for (
			innerIndex = 0;
			innerIndex < currentAPIList[index]?.metrics?.length;
			innerIndex++
		) {
			if (name?.toLowerCase() == currentAPIList[index]?.name?.toLowerCase()) {
				let metricName =
					enumToColumnNames[
						currentAPIList[index]?.metrics[innerIndex]?.shortName
					];
				let id = currentAPIList[index]?.metrics[innerIndex].id;
				let metricShortName =
					currentAPIList[index]?.metrics[innerIndex]?.shortName;

				if (metricName?.toLowerCase() == metric?.toLowerCase()) {
					element = {
						id: id,
						name: currentAPIList[index]?.metrics[innerIndex].name,
						channel: filterSelection.toUpperCase(),
						shortName: metricShortName,
					};
				}
			}
		}
	}
	return element;
};

export const getColumnList = (columnsArr) => {
	if (isEmpty(columnsArr)) {
		return {};
	}
	return columnsArr;
};

export const getColumnNames = (namesArr, columnsArr) => {
	let tempList = {
		OMNI: [],
		ECOM: [],
		STORE: [],
	};
	if (isEmpty(columnsArr)) {
		return tempList;
	}
	const channel = ['OMNI', 'STORE', 'ECOM'];
	if (
		!isEmpty(namesArr) &&
		(namesArr['OMNI']?.length > 0 ||
			namesArr['STORE']?.length > 0 ||
			namesArr['ECOM']?.length > 0)
	) {
		for (let i = 0; i < channel?.length; i++) {
			namesArr[channel[i]]?.forEach((obj) => {
				obj.metrics?.forEach((metric) => {
					tempList[channel[i]]?.push(enumToColumnNames[metric?.shortName]);
				});
			});
		}
	} else {
		for (let i = 0; i < channel?.length; i++) {
			columnsArr[channel[i]]?.forEach((obj) => {
				obj.metrics?.forEach((metric) => {
					tempList[channel[i]]?.push(enumToColumnNames[metric?.shortName]);
				});
			});
		}
	}
	return tempList;
};

export const getColumnNamesInEnum = (namesArr, columnsArr) => {
	let tempList = {
		OMNI: [],
		ECOM: [],
		STORE: [],
	};
	if (isEmpty(columnsArr)) {
		return tempList;
	}
	const channel = ['OMNI', 'STORE', 'ECOM'];
	if (
		!isEmpty(namesArr) &&
		(namesArr['OMNI']?.length > 0 ||
			namesArr['STORE']?.length > 0 ||
			namesArr['ECOM']?.length > 0)
	) {
		for (let i = 0; i < channel?.length; i++) {
			namesArr[channel[i]]?.forEach((obj) => {
				obj.metrics?.forEach((metric) => {
					tempList[channel[i]]?.push(metric?.shortName);
				});
			});
		}
	} else {
		for (let i = 0; i < channel?.length; i++) {
			columnsArr[channel[i]]?.forEach((obj) => {
				obj.metrics?.forEach((metric) => {
					tempList[channel[i]]?.push(metric?.shortName);
				});
			});
		}
	}
	return tempList;
};
